module.exports = __webpack_public_path__ + "img/d.f3922849.jpg";